<div class="p-4 md:p-6 h-full flex flex-col">
  <div class="w-full max-w-[90%] mx-auto flex flex-col flex-1 min-h-0">

    <!-- Header -->
    <div class="flex items-center gap-4 mb-4">
      <h2 class="text-2xl font-bold text-gray-800">Terminal</h2>
    </div>

    <!-- Device selector -->
    <div class="mb-4">
      @if (isLoadingDevices) {
        <div class="flex items-center gap-2 text-gray-500 text-sm">
          <app-spinner [size]="16" />
          Loading devices...
        </div>
      } @else {
        <select
          [ngModel]="selectedClientId ?? ''"
          (ngModelChange)="onDeviceChange($event)"
          class="border border-gray-300 rounded px-3 py-2 text-sm text-gray-800 bg-white focus:outline-none focus:ring-2 focus:ring-blue-400 w-full sm:w-auto sm:min-w-72">
          <option value="">Select a device...</option>
          @for (device of devices; track device.clientId) {
            <option [value]="device.clientId">{{ device.clientId }}</option>
          }
        </select>
      }
    </div>

    <!-- Terminal panel -->
    @if (selectedClientId) {
      <div class="flex-1 min-h-0">
        <app-terminal [clientId]="selectedClientId" />
      </div>
    } @else {
      <div class="flex-1 flex items-center justify-center text-gray-400 text-sm italic">
        Select a device to open a terminal session.
      </div>
    }

  </div>
</div>
